(function () {
  'use strict';

  angular
    .module('web2print')
    .directive('feedbackButton', feedbackButton);

  /* @ngInject */
  function feedbackButton () {
    const directive = {
      restrict: 'E',
      templateUrl: 'components/layout/feedback-button/feedback-button.html',
      link: linkFunc,
      controller: FeedbackButtonController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    function linkFunc (scope, el, attr, ctrl) {

    }
  }

  FeedbackButtonController.$inject = ['$rootScope', '$state', 'FeedbackButtonFactory'];

  /* @ngInject */
  function FeedbackButtonController ($rootScope, $state, FeedbackButtonFactory) {

    const vm = this;

    $rootScope.$on('$stateChangeSuccess', activate);
    $rootScope.$on('changeLanguage', function (events, language) {
      setLanguage(language);
    });

    activate();

    function activate () {
      const state = $state.current.name.replace('main.', '');
      const humanySettings = FeedbackButtonFactory.getHumanyWidget(state);

      // Destory humany widget if already existing to reload it with current page
      if (FeedbackButtonFactory.isHumanyLoaded()) {
        window.Humany && Humany.ready && Humany.Widgets.Coordinator.destroy(humanySettings.name);
      }

      FeedbackButtonFactory.loadHumany(humanySettings.name);
      setLanguage(pnTopbar.language);
    }

    function setLanguage (language) {
      vm.language = language === 'sv' ? 'sv' : 'en';
    }
  }
})();
